import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { AudioProvider } from "./contexts/AudioContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PersistentAudioPlayer from "./components/PersistentAudioPlayer";
import Home from "./pages/Home";
import Names from "./pages/Names";
import DailyVerse from "./pages/DailyVerse";
import Pilgrimage from "./pages/Pilgrimage";
import PilgrimageDetail from "./pages/PilgrimageDetail";
import Donate from "./pages/Donate";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Newsletter from "./pages/Newsletter";
import About from "./pages/About";
import SevaClub from "./pages/SevaClub";
import Teachers from "./pages/Teachers";
import TeacherApply from "./pages/TeacherApply";
import TeacherDetail from "./pages/TeacherDetail";
import TeacherDashboard from "./pages/TeacherDashboard";
import Transparency from "./pages/Transparency";
import Satsangs from "./pages/Satsangs";
import BookingDetail from "./pages/BookingDetail";
import SupplierApply from "./pages/SupplierApply";
import Advertise from "./pages/Advertise";
import Deities from "./pages/Deities";
import DeityDetail from "./pages/DeityDetail";
import Festivals from "./pages/Festivals";
import Jaagran from "./pages/Jaagran";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import SupplierDashboard from "./pages/SupplierDashboard";
import Bhajans from "./pages/Bhajans";
import Unsubscribe from "./pages/Unsubscribe";
import Renew from "./pages/Renew";
import Ecard from "./pages/Ecard";
import NgoProgram from "./pages/NgoProgram";
import NgoApply from "./pages/NgoApply";
import NgoDashboard from "./pages/NgoDashboard";
import Scholarships from "./pages/Scholarships";

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AudioProvider>
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1 pb-24">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/names" element={<Names />} />
                <Route path="/daily-verse" element={<DailyVerse />} />
                <Route path="/pilgrimage" element={<Pilgrimage />} />
                <Route path="/pilgrimage/:id" element={<PilgrimageDetail />} />
                <Route path="/donate" element={<Donate />} />
                <Route path="/seva-club" element={<SevaClub />} />
                <Route path="/teachers" element={<Teachers />} />
                <Route path="/teachers/apply" element={<TeacherApply />} />
                <Route path="/teachers/:id" element={<TeacherDetail />} />
                <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
                <Route path="/transparency" element={<Transparency />} />
                <Route path="/satsangs" element={<Satsangs />} />
                <Route path="/bookings/:session_id" element={<BookingDetail />} />
                <Route path="/become-supplier" element={<SupplierApply />} />
                <Route path="/advertise" element={<Advertise />} />
                <Route path="/deities" element={<Deities />} />
                <Route path="/deities/:slug" element={<DeityDetail />} />
                <Route path="/festivals" element={<Festivals />} />
                <Route path="/jaagran" element={<Jaagran />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:id" element={<ProductDetail />} />
                <Route path="/supplier/dashboard" element={<SupplierDashboard />} />
                <Route path="/bhajans" element={<Bhajans />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
                <Route path="/renew/:token" element={<Renew />} />
                <Route path="/ecard/:id" element={<Ecard />} />
                <Route path="/ngo" element={<NgoProgram />} />
                <Route path="/ngo/apply" element={<NgoApply />} />
                <Route path="/ngo/dashboard" element={<NgoDashboard />} />
                <Route path="/scholarships" element={<Scholarships />} />
                <Route path="/newsletter" element={<Newsletter />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/about" element={<About />} />
              </Routes>
            </main>
            <Footer />
            <PersistentAudioPlayer />
            <Toaster position="top-center" richColors />
          </div>
        </AudioProvider>
      </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}
